import { FETCH_GIFT_DETAILS } from '../../actions';
import createAggregatorReducer from '../../../../shared/app/stale-reducers/aggregator-reducer';

export default createAggregatorReducer({
  idProp: 'productNumber',
  startAction: FETCH_GIFT_DETAILS,
}).reducer;
